import commonEN from "./en/common"
import commonES from "./es/common"
import errorEN from "./en/error"
import errorES from "./es/error"
import migrationEN from "./en/migration"
import migrationES from "./es/migration"
import urlsEN from "./en/urls"
import urlsES from "./es/urls"
import footerEN from "./en/footer"
import footerES from "./es/footer"
import settingsEN from "./en/settings"
import settingsES from "./es/settings"

export const es = {
  common: commonES,
  error: errorES,
  migration: migrationES,
  urls: urlsES,
  footer: footerES,
  settings: settingsES,
}

export const en = {
  common: commonEN,
  error: errorEN,
  migration: migrationEN,
  urls: urlsEN,
  footer: footerEN,
  settings: settingsEN,
}
